import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "../pages/home/page";
import CompanyIndex from "../pages/company/page";
import CompanyMessage from "../pages/company/message/page";
import CompanyOfficers from "../pages/company/officers/page";
import CompanyOverview from "../pages/company/overview/page";
import CompanyPhilosophy from "../pages/company/philosophy/page";
import CompanyAccess from "../pages/company/access/page";
import GroupPage from "../pages/group/page";
import RecruitPage from "../pages/recruit/page";
import RecruitCategoryPage from "../pages/recruit/category/page";
import RecruitJobPage from "../pages/recruit/job/page";
import ContactPage from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "company", element: <CompanyIndex /> },
      { path: "company/message", element: <CompanyMessage /> },
      { path: "company/officers", element: <CompanyOfficers /> },
      { path: "company/overview", element: <CompanyOverview /> },
      { path: "company/philosophy", element: <CompanyPhilosophy /> },
      { path: "company/access", element: <CompanyAccess /> },
      { path: "group", element: <GroupPage /> },
      { path: "recruit", element: <RecruitPage /> },
      { path: "recruit/:categorySlug", element: <RecruitCategoryPage /> },
      { path: "recruit/:categorySlug/:jobSlug", element: <RecruitJobPage /> },
      { path: "contact", element: <ContactPage /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;